import { useTranslation } from 'react-i18next'
import { Construction } from 'lucide-react'

export function PlaceholderPage({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-8">
      <div className="bg-muted flex size-16 items-center justify-center rounded-2xl">
        <Construction className="text-muted-foreground size-8" />
      </div>
      <div className="text-center">
        <h1 className="text-foreground text-xl font-semibold">{t(titleKey)}</h1>
        <p className="text-muted-foreground mt-1 text-sm">
          {t('ekoolTeacher.placeholderDescription')}
        </p>
      </div>
    </div>
  )
}
